<template>
  <div class="info_box">
    <div class="title">
      公司基本信息
    </div>
    <el-form style="width: 660px;" :model="info_form" :rules="rules" label-position="top" ref="infoForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="公司简介" prop="intro">
        <el-input type="textarea" maxlength="1000" show-word-limit autosize placeholder="业务模式，公司规模等" v-model="info_form.intro">
        </el-input>
      </el-form-item>
      <el-form-item>
        <template #label>
          <span>发展历程 <span style="margin-left: 5px;color: #999999; font-size: 12px;">(非必填)</span></span>
        </template>
        <el-input type="textarea" maxlength="800" show-word-limit autosize placeholder="发展时间线、记录重要大事记" v-model="info_form.development_history">
        </el-input>
      </el-form-item>
      <el-form-item label="获得荣誉">
        <template #label>
          <span>获得荣誉 <span style="margin-left: 5px;color: #999999; font-size: 12px;">(非必填)</span></span>
        </template>
        <el-input type="textarea" maxlength="500" show-word-limit autosize placeholder="奖项、荣誉、专利、作品" v-model="info_form.company_honor">
        </el-input>
      </el-form-item>
      <el-form-item label="企业文化">
        <template #label>
          <span>企业文化 <span style="margin-left: 5px;color: #999999; font-size: 12px;">(非必填)</span></span>
        </template>
        <el-input type="textarea" maxlength="500" show-word-limit autosize placeholder="企业使命、愿景、战略、经营宗旨" v-model="info_form.company_culture">
        </el-input>
      </el-form-item>
    </el-form>
    <el-button class="save_button" @click="submitForm('infoForm')">保存</el-button>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      info_form: {
        intro: "", //企业简介
        development_history: "", //发展历程
        company_honor: "", //获得荣誉
        company_culture: "", //企业文化
      },
      rules: {
        intro: [
          { required: true, message: "请输入公司简介", trigger: "blur" },
          {
            min: 0,
            max: 1000,
            message: "长度在 0 到 1000 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getCompanyDetial();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$httpcompany.axiosPost(
            this.$api.companySaveIntroduction,
            this.info_form,
            (res) => {
              if (res.code == 200) {
                this.$message.success("保存成功");
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            }
          );
          //
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCompanyDetial() {
      this.$httpcompany.axiosGet(this.$api.companyDetail, (res) => {
        if (res.code == 200) {
          for (const key in this.info_form) {
            if (key in res.data && res.data[key]) {
              this.info_form[key] = res.data[key];
            }
          }
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.info_box {
  padding-bottom: 20px;
  .title {
    font-weight: 500;
    font-size: 20px;
    color: #393837;
    margin-bottom: 24px;
  }
}
.save_button {
  width: 86px;
  height: 34px;
  background: #685ef5;
  border-radius: 4px 4px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}
::v-deep .el-textarea__inner {
  height: 100px !important;
}
</style>